import { formatDatum } from '../lib/aktivitaet.js';

// Einheitliche Wiedervorlage-Markierung an allen Stellen.
//
// Trigger (rendert nur, wenn eines der beiden zutrifft):
//   - ist_wiedervorlage === true (neues Modell: die Aktivität IST eine Wiedervorlage)
//   - wiedervorlage_am gesetzt   (Altbestand-Kompatibilität)
//
// Badge-Text:
//   - neues Modell  → "Wiedervorlage" (kein Datum, weil das relevante Datum
//                     bereits faellig_am der Aktivität ist)
//   - Altbestand    → "Wiedervorlage · DD.MM.YYYY"
//
// Varianten:
//   icon  — nur das ⏰-Glöckchen
//   badge — nur die Amber-Pille
//   both  — Glöckchen + Pille nebeneinander (Default)
//
// Farbe: einheitlich kräftiges Amber. Die alte Unterscheidung
// "aktiv vs. zukünftig" entfällt im neuen Modell, weil eine Wiedervorlage
// per Konstruktion sofort relevant ist.
export default function WiedervorlageMarkierung({
  ist_wiedervorlage: istWiedervorlage = false,
  wiedervorlage_am: wiedervorlageAm = null,
  variant = 'both',
}) {
  if (!istWiedervorlage && !wiedervorlageAm) return null;

  const labelText = istWiedervorlage
    ? 'Wiedervorlage'
    : `Wiedervorlage · ${formatDatum(wiedervorlageAm)}`;

  const icon = (
    <span aria-hidden="true" className="text-amber-700">
      ⏰
    </span>
  );

  const badge = (
    <span className="inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-900">
      {labelText}
    </span>
  );

  if (variant === 'icon') return icon;
  if (variant === 'badge') return badge;
  return (
    <span className="inline-flex items-center gap-1.5">
      {icon}
      {badge}
    </span>
  );
}
